import { render, staticRenderFns } from "./is-copyright.vue?vue&type=template&id=41d9c346&scoped=true"
import script from "./is-copyright.vue?vue&type=script&lang=ts"
export * from "./is-copyright.vue?vue&type=script&lang=ts"
import style0 from "./is-copyright.vue?vue&type=style&index=0&id=41d9c346&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d9c346",
  null
  
)

export default component.exports